/**
 * 安全教育考试api
 */
import * as API from '../'

export default {
    /**
     * 题库列表
     */
    getQuestionBankList: params => {
        return API.GET(`/mall/m/training/library/pageList`, params)
    },
    /**
     * 课程 option 列表
     */
    getProgramOptions:  params => {
      return API.GET(`/mall/m/training/program/options`, params)
    },
    /**
     * 题库详情查询
     */
    getQuestionBankDetail: params => {
        return API.GET(`/mall/m/training/library/getDataDetail`, params)
    },
    /**
     * 试题目录
     */
    getCatalogList: params => {
        return API.GET(`/mall/m/training/directory/getList`, params)
    },
    /**
     * 加载师资option列表
     */
    getTeachersOptions: params => {
      return API.GET(`/mall/m/tranning/teachers/options`, params)
    },
    /**
     * 题库增加
     */
    addLibrary: params => {
        return API.POST(`/mall/m/training/library/add`, params)
    },
    /**
     * 题库
     */
    delLibrary: params => {
        return API.POST(`/mall/m/training/library/deleteQuestion`, params)
    },
    /**
     * 题库修改
     */
    updateLibrary: params => {
        return API.POST(`/mall/m/training/library/modify`, params)
    },

    /**
     * 试卷列表
     */
    getPaperList: params => {
        return API.GET(`/mall/m/traning/paper/pageList`, params)
    },
    //添加试卷
    addPaper: params => {
        return API.POST(`/mall/m/traning/paper/add`, params)
    },
    getPaperDetail: params => {
        return API.POST(`/mall/m/traning/paper/getDataDetail`, params)
    },
    getPaperNewDetail: params => {
        return API.POST(`/mall/m/traning/paper/getNewDataDetail`, params)
    },
    copyPaper: params => {
        return API.POST(`/mall/m/traning/paper/copy`, params)
    },
    updatePaper: params => {
        return API.POST(`/mall/m/traning/paper/modify`, params)
    },
    importPaper: params => {
      return API.POST(`/mall/m/traning/paper/import`, params)
    },
    addPaperDetail: params => {
        return API.GET(`/mall/m/traning/paper/getSaveDetail`, params)
    },
    //删除试卷
    delPaper: params => {
        return API.POST(`/mall/m/traning/paper/deletePaper`, params)
    },
    /**
     * 题库管理-根据目录查询对应题库
     */
    getLibraryListById: params => {
        return API.GET(`/mall/m/training/library/getDataList`, params)
    },
    /**
     * 考试管理-列表查询(考试统计)
     */
    examStatisticsList: params => {
        return API.GET(`/mall/m/training/detail/list/pageList`, params)
    },
    /**
     * 题库导出
     */
    libraryExportQuestion: params => {
        return API.POST(`/mall/m/training/library/exportQuestion`, params)
    },
    examManageSave: params => {
        return API.POST(`/mall/m/training/detail/list/save`, params)
    },
    /**
     * 考试统计
     */
    trainingStatisticsList: params => {
        return API.GET(`/mall/m/training/detail/count/pageList`, params)
    },
    /**
     * 考试统计详情
     */
    trainingStatisticsListDetail: params => {
        return API.GET(`/mall/m/training/detail/count/getDetil`, params)
    },
    getNewExamDetail: params => {
        return API.GET(`/mall/m/training/program/getNewExamDetail`, params)
    },
    importData: params => {
        return API.POST(`/mall/m/training/library/uploadExcel`, params)
    },
    downExcel: params => {
        return API.POST(`/mall/m/training/library/downExcel`, params)
    },
    directoryList: params => {
        return API.GET(`/mall/m/training/directory/pageList`, params)
    },
    saveDirectory: params => {
        return API.POST(`/mall/m/training/directory/save`, params)
    },
    delDirectory: params => {
        return API.POST(`/mall/m/training/directory/deleteOrAble`, params)
    },
    exportExcel: params => {
        return API.GETBLOB(`/mall/m/training/library/exportExcel`, params)
    },
    trainingDetailExport: params => {
        return API.GETBLOB(`/mall/m/training/detail/count/export`, params)
    },
    trainingDetailExportPaper: params => {
        return API.GETBLOB(`/mall/m/training/detail/count/exportPaper`, params)
    },
}



// WEBPACK FOOTER //
// ./src/api/mall/exam.js